module.exports = __webpack_public_path__ + "img/appel.02486390.png";